import { put } from 'redux-saga/effects';

import AppAction, { IsIdleAction } from 'actions/app/AppAction';

export default function* (action: IsIdleAction) {
  if (action.payload === true) {
    yield put(AppAction.restart());
  }
}
